async function sha256(text) {
  const enc = new TextEncoder().encode(text);

  // Safe-guard: call crypto.subtle.digest only if available
  if (typeof crypto?.subtle?.digest === 'function') {
    const buf = await crypto.subtle.digest('SHA-256', enc);
    return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
  }

  // Deterministic fallback hash (FNV-1a on bytes) — avoids runtime crash
  let hash = 2166136261 >>> 0;
  for (let i = 0; i < enc.length; i++) {
    hash ^= enc[i];
    hash = Math.imul(hash, 16777619) >>> 0;
  }
  const hex = hash.toString(16).padStart(8, '0');
  return hex + hex + hex + hex; // 32 hex chars (deterministic fallback)
}

async function getOrCreateDeviceId() {
  const ua = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const hc = navigator.hardwareConcurrency || 1;
  const screenRes = `${screen.width || 0}x${screen.height || 0}`;
  const tz = (Intl?.DateTimeFormat?.().resolvedOptions?.().timeZone) || '';

  // Canvas fingerprint — guarded
  const canvas = document.createElement('canvas');
  let canvasData = '';
  const ctx = canvas.getContext('2d');
  if (ctx) {
    try {
      ctx.textBaseline = 'top';
      ctx.font = '14px Arial';
      ctx.fillText('fingerprint-test', 2, 2);
      canvasData = canvas.toDataURL();
    } catch (e) {
      canvasData = '';
    }
  }

  const raw = [ua, platform, hc, screenRes, tz, canvasData].join('||');
  return sha256(raw);
}

export default getOrCreateDeviceId;